module.exports = __webpack_public_path__ + "static/img/right.899995e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = 1108
// module chunks = 4